import './admin_notification_style.scss';
import onDocumentReady from 'shared/onDocumentReady';
import { createApp } from '~/vue/createApp';
import AdminNotification from './AdminNotification.vue';

// see site_header/index.js for what the conversion from `new Vue({el, render})` changes. This
// is the only one of the five carrying anything in: the props the render function used to
// build a `{props}` bucket for are the second argument to createApp now
function initVue() {
    const el = document.getElementById('admin-notification-component');
    if (!el) {
        return;
    }
    const props = {
        notificationText: el.dataset.notificationText || '',
    };
    if (el.dataset.color) {
        props.color = el.dataset.color;
    }
    if (el.dataset.backgroundColor) {
        props.backgroundColor = el.dataset.backgroundColor;
    }
    createApp(AdminNotification, props).mount(el);
}

onDocumentReady(initVue);
